module.exports = __webpack_public_path__ + "media/apps/mitch-ios-7-0a3867aa.png";